import React, { useEffect, useState } from 'react';
import { api } from '../api/client';

export default function TenantsPage() {
  const [tenants, setTenants] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', slug: '', domain: '', plan: 'basic', contact_email: '', contact_phone: '' });
  const [edit, setEdit] = useState<null | { id: string; name: string; plan: string; max_units: string; unit_count: number }>(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState('');

  const loadTenants = () => {
    api.get('/platform/tenants?limit=500').then(res => setTenants(res?.items || (Array.isArray(res) ? res : []))).catch(() => {}).finally(() => setLoading(false));
  };

  useEffect(loadTenants, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    await api.post('/platform/tenants', form);
    setShowForm(false);
    setForm({ name: '', slug: '', domain: '', plan: 'basic', contact_email: '', contact_phone: '' });
    loadTenants();
  };

  const savePlan = async () => {
    if (!edit) return;
    const n = parseInt(edit.max_units || '0', 10);
    if (!n || n < edit.unit_count) { alert(`Айлын хязгаар бүртгэлтэй ${edit.unit_count} айлаас багагүй байх ёстой`); return; }
    setBusy(true);
    try {
      await api.put(`/platform/tenants/${edit.id}/plan`, { plan: edit.plan, max_units: n });
      setEdit(null); loadTenants(); setMsg('Багц, хязгаар шинэчлэгдлээ'); setTimeout(() => setMsg(''), 3000);
    } catch (e: any) { alert(e?.body ? (JSON.parse(e.body)?.detail || 'Алдаа') : (e?.message || 'Алдаа')); }
    finally { setBusy(false); }
  };

  return (
    <div>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 24 }}>
        <h2 style={{ fontFamily: "'Inter'", fontWeight: 700, color: '#1c2b22' }}>СӨХ удирдлага</h2>
        <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
          {msg && <span style={{ fontSize: 13, color: '#236844', fontWeight: 600 }}>✓ {msg}</span>}
          <button onClick={() => setShowForm(!showForm)} style={btnPrimary}>{showForm ? 'Болих' : '+ Шинэ СӨХ'}</button>
        </div>
      </div>

      {showForm && (
        <div style={card}>
          <form onSubmit={handleSubmit} style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <Input label="Нэр" value={form.name} onChange={v => setForm({ ...form, name: v })} />
            <Input label="Slug" value={form.slug} onChange={v => setForm({ ...form, slug: v })} />
            <Input label="Домайн" value={form.domain} onChange={v => setForm({ ...form, domain: v })} />
            <div>
              <label style={labelStyle}>Төлөвлөгөө</label>
              <select value={form.plan} onChange={e => setForm({ ...form, plan: e.target.value })} style={inputStyle}>
                <option value="basic">Basic</option>
                <option value="professional">Professional</option>
                <option value="enterprise">Enterprise</option>
              </select>
            </div>
            <Input label="И-мэйл" value={form.contact_email} onChange={v => setForm({ ...form, contact_email: v })} />
            <Input label="Утас" value={form.contact_phone} onChange={v => setForm({ ...form, contact_phone: v })} />
            <div style={{ gridColumn: '1 / -1' }}>
              <button type="submit" style={btnPrimary}>Хадгалах</button>
            </div>
          </form>
        </div>
      )}

      {loading ? <p>Уншиж байна...</p> : (
        <div style={card}>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr style={{ borderBottom: '2px solid #e8e5dc', textAlign: 'left' }}>
                <th style={th}>Нэр</th>
                <th style={th}>Slug</th>
                <th style={th}>Багц</th>
                <th style={th}>Айл / хязгаар</th>
                <th style={th}>Статус</th>
                <th style={th}>И-мэйл</th>
                <th style={th}></th>
              </tr>
            </thead>
            <tbody>
              {tenants.map((t: any) => (
                <tr key={t.id} style={{ borderBottom: '1px solid #e8e5dc' }}>
                  <td style={td}>{t.name}</td>
                  <td style={td}>{t.slug}</td>
                  <td style={td}><Badge text={t.plan} /></td>
                  <td style={td}><UnitUsage used={t.unit_count || 0} max={t.max_units || 0} /></td>
                  <td style={td}><StatusBadge status={t.status} /></td>
                  <td style={td}>{t.contact_email}</td>
                  <td style={{ ...td, whiteSpace: 'nowrap' }}>
                    <button onClick={() => setEdit({ id: t.id, name: t.name, plan: t.plan, max_units: String(t.max_units || 0), unit_count: t.unit_count || 0 })} style={btnGhost}>Багц / хязгаар</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {edit && (
        <div style={overlay} onClick={() => setEdit(null)}>
          <div style={{ ...card, width: 420, maxWidth: '92vw', marginBottom: 0 }} onClick={e => e.stopPropagation()}>
            <h3 style={{ margin: '0 0 4px', fontSize: 17, color: '#1c2b22' }}>{edit.name}</h3>
            <p style={{ margin: '0 0 14px', fontSize: 13, color: '#5f6f66' }}>Бүртгэлтэй <b>{edit.unit_count}</b> айл. Хязгаарт хүрсэн үед шинэ айл нэмэхэд «Unit limit reached» алдаа гарна.</p>
            <label style={labelStyle}>Багц</label>
            <select value={edit.plan} onChange={e => setEdit({ ...edit, plan: e.target.value, max_units: String(PLAN_LIMITS[e.target.value] ?? edit.max_units) })} style={inputStyle}>
              <option value="basic">Basic — 150 айл</option>
              <option value="standard">Standard — 500 айл</option>
              <option value="pro">Pro — 1500 айл</option>
              <option value="enterprise">Enterprise — хязгааргүй</option>
            </select>
            <div style={{ height: 12 }} />
            <label style={labelStyle}>Айлын хязгаар</label>
            <input type="number" min={edit.unit_count} value={edit.max_units} onChange={e => setEdit({ ...edit, max_units: e.target.value })} style={inputStyle} />
            <p style={{ margin: '6px 0 0', fontSize: 12.5, color: '#5f6f66' }}>Багц сонгоход анхдагч хязгаар тавигдана; тусгай тохиролцоотой бол гараар өөрчилнө.</p>
            <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 16 }}>
              <button onClick={() => setEdit(null)} style={btnGhost}>Болих</button>
              <button onClick={savePlan} disabled={busy} style={{ ...btnPrimary, opacity: busy ? .6 : 1 }}>{busy ? 'Хадгалж байна…' : 'Хадгалах'}</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const PLAN_LIMITS: Record<string, number> = { basic: 150, standard: 500, pro: 1500, enterprise: 99999 };

/** Айлын ашиглалт: 100 = хязгаартаа хүрсэн (улаан), 90%+ шар. */
function UnitUsage({ used, max }: { used: number; max: number }) {
  const pct = max > 0 ? Math.min(100, Math.round((used / max) * 100)) : 0;
  const tone = used >= max ? '#b3412f' : pct >= 90 ? '#b8860b' : '#2f7d52';
  return (
    <div style={{ minWidth: 118 }}>
      <div style={{ fontSize: 13.5, fontWeight: 600, color: tone }}>{used} / {max >= 99999 ? '∞' : max}{used >= max && max < 99999 ? ' · дүүрсэн' : ''}</div>
      <div style={{ height: 5, background: '#e8e5dc', borderRadius: 3, marginTop: 4, overflow: 'hidden' }}>
        <div style={{ width: `${pct}%`, height: '100%', background: tone }} />
      </div>
    </div>
  );
}

function Input({ label, value, onChange }: { label: string; value: string; onChange: (v: string) => void }) {
  return (
    <div>
      <label style={labelStyle}>{label}</label>
      <input value={value} onChange={e => onChange(e.target.value)} style={inputStyle} />
    </div>
  );
}

function Badge({ text }: { text: string }) {
  const colors: Record<string, string> = { basic: '#3b82f6', professional: '#8b5cf6', enterprise: '#f59e0b' };
  return (
    <span style={{
      background: (colors[text] || '#6b7280') + '20', color: colors[text] || '#6b7280',
      padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
    }}>{text}</span>
  );
}

function StatusBadge({ status }: { status: string }) {
  const colors: Record<string, string> = { active: '#10b981', inactive: '#ef4444', trial: '#f59e0b' };
  return (
    <span style={{
      background: (colors[status] || '#6b7280') + '20', color: colors[status] || '#6b7280',
      padding: '2px 8px', borderRadius: 4, fontSize: 12, fontWeight: 600,
    }}>{status}</span>
  );
}

const btnPrimary: React.CSSProperties = {
  background: 'linear-gradient(180deg, #2f7d52, #236844)', color: '#fff', border: 'none', padding: '8px 20px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 14, fontFamily: "'Inter'",
};
const btnGhost: React.CSSProperties = {
  background: '#fff', color: '#2a3b32', border: '1.5px solid #dcdacf', padding: '7px 14px',
  borderRadius: 10, cursor: 'pointer', fontWeight: 600, fontSize: 13.5, fontFamily: "'Inter'",
};
const overlay: React.CSSProperties = {
  position: 'fixed', inset: 0, background: 'rgba(28,43,34,.45)', display: 'flex', alignItems: 'center',
  justifyContent: 'center', zIndex: 60, padding: 16,
};
const card: React.CSSProperties = {
  background: '#fff', borderRadius: 12, padding: 20, boxShadow: '0 1px 3px rgba(0,0,0,0.06)', marginBottom: 16,
};
const labelStyle: React.CSSProperties = { display: 'block', marginBottom: 4, fontSize: 13, color: '#2a3b32', fontWeight: 500 };
const inputStyle: React.CSSProperties = {
  width: '100%', padding: '8px 12px', border: '1.5px solid #dcdacf', borderRadius: 10, fontSize: 14, boxSizing: 'border-box', background: '#fbfaf6',
};
const th: React.CSSProperties = { padding: '10px 12px', fontSize: 13, color: '#5f6f66', fontWeight: 600 };
const td: React.CSSProperties = { padding: '10px 12px', fontSize: 14, color: '#1c2b22' };
